import React, { Component } from 'react'
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';
import Slider from "react-slick"
import { throttle, isMobile, equalHeight } from "../../utilities/FrontFunctions/AoxGlobalFrontFunctions"

import ObjPushCardFormation from './ObjPushCardFormation'

import '../../assets/css/0020_objects/0680_obj_mes_formations_filtre.css'
import '../../assets/css/0020_objects/0690_obj_filtre_mes_formations.css'
import '../../assets/css/0020_objects/0621_obj_carrousel_slider.css'

class ObjMesFormationsFiltre extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isMobile: isMobile()
		}
		this.handleWindowResizeMainHeader = this.handleWindowResizeMainHeader.bind(this)
		this.throttleWindowResizeMainHeader = throttle(this.handleWindowResizeMainHeader, 200)
		this.handleButtonFav = this.props.handleButtonFav.bind(this)
	}

	handleWindowResizeMainHeader() {
		this.setState({
			isMobile: isMobile()
		})
		this.applyEqualHeight()
	}

    componentDidMount() {
		this.applyEqualHeight()
		window.addEventListener('resize', this.throttleWindowResizeMainHeader)
    }
    componentWillUnmount() {
		window.removeEventListener('resize', this.throttleWindowResizeMainHeader)
	}
	applyEqualHeight() {
		setTimeout(() => {
			equalHeight(".obj_mes_formations_filtre .obj_push_card .ctn_text_card");
		});
	}

    onSwipe() {
        if (this.slider) {
          	this.slider.innerSlider.clickable = true;
        }
	}

	render() {
        const { datasTrainings, dataThemeTitle } = this.props;

		const sliderRef = slider => {this.slider = slider}
        const settings = {
            className: "obj_carousel_formation obj_carrousel_slider",
            centerMode: true,
			infinite: false,
			slidesToShow: 1,
			swipeToSlide: true,
			onSwipe: this.onSwipe.bind(this),
            // variableWidth: true,
			centerPadding: "10%",
            dots: true,
            dotsClass: "slider-nav",
            appendDots: dots => (
                <div className="slider-nav" >
                    <ul> {dots} </ul>
                </div>
            ),
            arrows: false,
            speed: 750,
        }

		return (<>{datasTrainings && <>
			<div className="obj_mes_formations_filtre">
				<div className="ctn_title">
					<h3 className="t_title">Mes formations {dataThemeTitle?.jss.value}</h3>
					<p className="t_desc">{`${datasTrainings.length} formation${datasTrainings.length > 1 ? "s" : ""}`}</p>
				</div>

				{ this.state.isMobile &&
					<div className="ctn_carrousel">
						<Slider {...settings} ref={sliderRef}>
                            {datasTrainings.map((datasTraining, index) => (
                                <div className="item" key={index} >
                                    <ObjPushCardFormation typeofPush="Formation" datasTraining={datasTraining} handleButtonFav={this.handleButtonFav}/>
                                </div>
                            ))}
						</Slider>
					</div>
				}

				{!this.state.isMobile &&
					<div className="ctn_row">
                        {datasTrainings.map((datasTraining, index) => (
                            <ObjPushCardFormation key={index} typeofPush="Formation" datasTraining={datasTraining} handleButtonFav={this.handleButtonFav}/>
                        ))}
					</div>
				}
				
			</div>
        </>}</>)
	}

}

export default withTranslation()(withSitecoreContext()(ObjMesFormationsFiltre));